import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';
import { NestedPageLayout } from '#apps/client-web/app/components/nested-page-layout';

import { AuditFormWindowsPageContainer } from './audit-form-windows-page.container';
import { useAuditFormWindowsPageViewModel } from './audit-form-windows-page.view-model';

export const AuditFormWindowsPage = () => {
  const logger = useLogger('pages/audit-form-windows');

  const viewModel = useAuditFormWindowsPageViewModel({
    auditFormService,
    fileStorageService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <NestedPageLayout title="Windows">
      <AuditFormWindowsPageContainer viewModel={viewModel} logger={logger} />
    </NestedPageLayout>
  );
};
